<script lang="ts">
	interface Props {
		direction?: 'normal' | 'reverse';
	}

	let { direction = 'normal' }: Props = $props();

	const LEGEND_COLORS = ['green', 'gray', 'red'];

	let colors = $derived(direction === 'normal' ? LEGEND_COLORS : LEGEND_COLORS.slice().reverse());
</script>

<div class="mb-2 grid grid-flow-col justify-between gap-2">
	{#each ['+1 Standard Deviation', 'Average', '-1 Standard Deviation'] as key, i}
		<div class="legend {colors[i]}">{key}</div>
	{/each}
</div>

<style lang="postcss">
	@reference '../../app.css';

	.legend {
		@apply small-regular text-gray-dark relative flex items-center pl-8;
		&:before {
			@apply absolute top-1/2 left-0 w-6 -translate-y-1/2;
			content: ' ';
			height: 2px;
		}

		&.green {
			&:before {
				@apply bg-green-ticker;
			}
		}

		&.gray {
			&:before {
				@apply bg-gray-mid;
			}
		}

		&.red {
			&:before {
				@apply bg-red-ticker;
			}
		}
	}
</style>
